module.exports = __webpack_public_path__ + "img/store-img.6e8a8f98.jpg";